<template>
  <div>
    <appHeader></appHeader>
    <div class="container-fluid add-client">
      <div class="row">
        <div class="col-md-3 col-sm-12 pr-0 dark-bg">
          <appAdminSidebar></appAdminSidebar>
        </div>
        <transition appear name="fade">
          <div class="col-md-9 p-4">
            <h4>Add Client</h4>
            <div class="mb-2 rounded p-2" style="background-color: #f5f5f5;">
              <router-link
                :to="{ name: 'ManageClients' }"
                class="d-inline"
                style="font-weight: normal;"
              >
                Clients
              </router-link>
              <p class="d-inline pl-1 pr-1">/</p>
              <router-link
                :to="{}"
                class="d-inline"
                style="font-weight: normal;"
              >
                Add client
              </router-link>
            </div>
            <hr />
            <addClientForm></addClientForm>
            <router-view />
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import divvyAdminSidebar from "@/views/divvyadmin/divvyAdminSidebar.vue";
import AddClientForm from "./AddClientForm.vue";

export default {
  name: "AddClient",
  components: {
    appHeader: Header,
    appAdminSidebar: divvyAdminSidebar,
    addClientForm: AddClientForm,
  },

  methods: {
    setActiveMenuItem: function() {
      this.$store.dispatch("divvyAdminSidebar/setActive", {
        activeMenuItem: this.activeMenuItem
          ? this.activeMenuItem
          : "manageClients",
        activeMenu: this.activeMenu ? this.activeMenu : "clientusermanagement",
      });
    },
  },

  created() {
    this.setActiveMenuItem();
  },
};
</script>
<style lang="scss" scoped>

.add-client {
//   margin: 70px 0 0 0;
  min-height: 100%;
  margin: -14px 0 0 0;
  .badge {
    font-size: 0.8rem;
    padding: 6px 0px;
    border-radius: $border-radius-sm;
  }
}
.marginAll {
  margin: 10px;
}

html,
body {
  height: 100%;
}
</style>
